export default "__VITE_ASSET__DAN$huqW__"